import React, { useEffect, useState } from 'react';
import './index.css';
import { updateIsMentor } from '../../../api/userRequest';
import Profileandevents from '../../Landing/Profileandevents';
import { toast } from 'react-hot-toast';
import Mobilecommonhead from '../../Mobilecommonhead';
import { useNavigate } from 'react-router-dom';

function Account({ userData, setProgress }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState(userData.email);
  const [whats, setWhats] = useState(userData.whatsappNumber);
  const [upi, setUpi] = useState(userData.upiId);
  const [linkedindata, setlinkedindata] = useState(userData.linkedinId);
  const [name, setName] = useState(
    userData.firstname + ' ' + userData.lastname
  );
  const [username, setUsername] = useState(userData.username);

  useEffect(() => {
    var inp1 = document.querySelectorAll('.editable-input');
    for (let i = 0; i <= 3; i++) {
      inp1[i].disabled = true;
    }
  }, []);

  const [editMode, setEditMode] = useState(false);

  const enabledisableinput = async () => {
    if (!editMode) {
      // Enable edit mode
      setEditMode(true);
      // Optionally, you can focus on the first editable input field
      document.getElementById('account-name').focus();
    }
    var inp = document.querySelectorAll('.editable-input');
    if (inp[0].disabled) {
      for (let i = 0; i <= 3; i++) {
        inp[i].disabled = false;
      }
      document.querySelector('.edit-input').style.backgroundColor = '#108CFF';
      // document.querySelector(".edit-input").style.color = "black";
      document.querySelector('.edit-input').textContent = 'Save';
      for (let item of document.querySelectorAll('.editable-input')) {
        item.style.border = '2px solid black';
        item.style.borderRadius = '10px';
      }
    } else {
      try {
        setProgress(20);
        const request = {
          firstname: name.split(' ')[0],
          lastname: name.split(' ')[1],
          whatsappNumber: whats,
          linkedinId: linkedindata,
          upiId: upi,
        };
        if (username !== userData.username) {
          request.username = username;
        }
        await updateIsMentor(request);
        setProgress(100);
        toast.success('Account info updated!');
      } catch (error) {
        setEmail(userData.email);
        setWhats(userData.whatsappNumber);
        setUpi(userData.upiId);
        setlinkedindata(userData.linkedin);
        toast.error(error.response.data.error);
        setProgress(100);
      }

      setEditMode(false);

      // window.location.reload();
      for (let i = 0; i <= 3; i++) {
        inp[i].disabled = true;
      }

      for (let item of document.querySelectorAll('.editable-input')) {
        item.style.border = 'none';
      }

      // document.querySelector(".edit-input").style.backgroundColor = "black";
      document.querySelector('.edit-input').style.color = 'white';
      document.querySelector('.edit-input').textContent = 'Edit';
    }
  };

  return (
    <>
      <Mobilecommonhead />

      <div className='dash-main account-dash-main'>
        {/* <Commondash userData={ userData} /> */}

        <div className='dash-right dash-right-2'>
          {/* <Topbar setProgress={setProgress}/> */}
          <div className='account-page'>
            <h1 className='font-semibold text-2xl mb-5'>
              Edit Account Information
            </h1>
            <div className='account-card'>
              <div className='account-field'>
                <label htmlFor='account-name' className='account-label'>
                  Name
                </label>
                <input
                  type='text'
                  id='account-name'
                  placeholder={name}
                  className='editable-input textarea'
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className='account-field'>
                <label htmlFor='account-username' className='account-label'>
                  Username
                </label>
                <input
                  type='text'
                  id='account-username'
                  placeholder={username}
                  className='editable-input textarea'
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>
              <div className='account-field'>
                <label htmlFor='email' className='account-label'>
                  Email
                </label>
                <input
                  type='email'
                  id='email'
                  placeholder={email}
                  value={email}
                  readOnly
                  onClick={() => toast.error("Email can't be edited!")}
                  className='editable-input textarea'
                />
              </div>
              <div className='account-field'>
                <label htmlFor='phone' className='account-label'>
                  Phone
                </label>
                <input
                  type='number'
                  id='phone'
                  placeholder={whats}
                  value={whats}
                  className='editable-input textarea'
                  onChange={(e) => setWhats(e.target.value)}
                />
              </div>
              <div className='account-field'>
                <label htmlFor='linkedin' className='account-label'>
                  LinkedIn
                </label>
                <input
                  type='text'
                  id='linkedin'
                  placeholder={linkedindata}
                  className='editable-input textarea'
                  value={linkedindata}
                  onChange={(e) => setlinkedindata(e.target.value)}
                  disabled={!editMode}
                />
              </div>
              <div className='account-field'>
                <label htmlFor='upi' className='account-label'>
                  UPI ID
                </label>
                <input
                  type='text'
                  id='upi'
                  placeholder={upi}
                  value={upi}
                  className='editable-input textarea'
                  onChange={(e) => setUpi(e.target.value)}
                  disabled={!editMode}
                />
              </div>
              <div className='editor-ids'>
                <button
                  className='edit-pass'
                  onClick={() => navigate('/changePassword')}
                >
                  Change Password
                </button>
                <button className='edit-input' onClick={enabledisableinput}>
                  Edit
                </button>
              </div>
            </div>
          </div>
        </div>
        <Profileandevents />
      </div>
    </>
  );
}

export default Account;